import { render, staticRenderFns } from "./IdLikeToBanner.vue?vue&type=template&id=87cfdc04"
import script from "./IdLikeToBanner.vue?vue&type=script&lang=js"
export * from "./IdLikeToBanner.vue?vue&type=script&lang=js"
import style0 from "./IdLikeToBanner.vue?vue&type=style&index=0&id=87cfdc04&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports